import { render } from "./RoutePengaduan.vue?vue&type=template&id=27c54315"
import script from "./RoutePengaduan.vue?vue&type=script&lang=js"
export * from "./RoutePengaduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__